import { render, staticRenderFns } from "./EditPersonDialog.vue?vue&type=template&id=510e38eb&scoped=true"
import script from "./EditPersonDialog.vue?vue&type=script&lang=js"
export * from "./EditPersonDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPersonDialog.vue?vue&type=style&index=0&id=510e38eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e38eb",
  null
  
)

export default component.exports